export const subPages = {
    OVERVIEW: 'Overview',
    PROFILE_INFORMATION: 'Profile Information',
    EMPLOYMENT_INFORMATION: 'Employment Information',
    INTERVIEWS: 'Interviews',
    PROFILE_CV: '/profile-cv'
}
